import { Box, Container, Typography } from "@material-ui/core";
import React from "react";
import HolidayPreferencesGrid from "../../view/home/HolidayPreferencesGrid";
import { useI18N } from "../../../common/common";
import { useBreakpoints } from "../../../hooks";

const HomeFiltersSection = () => {
    const {i18n} = useI18N();
    const {isExtraSmallScreen, isSmallScreen} = useBreakpoints();

    return (
        <Box
            py={isExtraSmallScreen() || isSmallScreen() ? 8 : 10}
            bgcolor={"#F4F4ED"}
        >
            <Container>
                <Box
                    mb={isExtraSmallScreen() || isSmallScreen() ? 3 : 4}
                >
                    <Typography
                        variant="h3"
                        component="h2"
                    >
                        {i18n("view.home.destinations_to_suit_taste")}
                    </Typography>
                </Box>
                <HolidayPreferencesGrid />
            </Container>
        </Box>
    );
    
};

export default HomeFiltersSection;